import axios from 'axios'
import { DEFAULT_ADMIN_PATH, DEFAULT_CHIEF_PATH } from '@/constants/axios'
import type { PaginatedData } from '@/types/httpResponse'
import type { PaymentMethod } from '@/types/acquiring'
import type {
  GetPaymentsPayload,
  GetPaymentsResponse,
  GetAdminPaymentsPayload,
  GetAdminPaymentsResponse,
} from '@/types/payments'
import type { DefaultGetPayload } from '@/types/main'

export const getPaymentSystemsApiCall = async (
  abortController?: AbortController,
  params?: DefaultGetPayload,
): Promise<PaginatedData<PaymentMethod[]>> => {
  const { data } = await axios.get(`${DEFAULT_CHIEF_PATH}/payment-systems`, {
    params,
    signal: abortController?.signal,
  })
  return data.data
}

export const getPaymentsApiCall = async (
  abortController?: AbortController,
  params?: GetPaymentsPayload,
): Promise<GetPaymentsResponse> => {
  const { data } = await axios.get(`${DEFAULT_CHIEF_PATH}/payments/success`, {
    params,
    signal: abortController?.signal,
  })
  return data
}

export const getPaymentsSumApiCall = async (
  abortController?: AbortController,
  params?: Omit<GetPaymentsPayload, 'page'>,
): Promise<{ sum: number }> => {
  const { data } = await axios.get(`${DEFAULT_CHIEF_PATH}/payments/sum`, {
    params,
    signal: abortController?.signal,
  })
  return data.data
}

export const getAdminPaymentsApiCall = async (
  abortController?: AbortController,
  params?: GetAdminPaymentsPayload,
): Promise<GetAdminPaymentsResponse> => {
  const { data } = await axios.get(`${DEFAULT_ADMIN_PATH}/finance/payments`, {
    params,
    signal: abortController?.signal,
  })
  return data
}

export const getAdminPaymentsSumApiCall = async (
  abortController?: AbortController,
  params?: Omit<GetAdminPaymentsPayload, 'page'>,
): Promise<{ amount: number }> => {
  const { data } = await axios.get(`${DEFAULT_ADMIN_PATH}/finance/payments/total`, {
    params,
    signal: abortController?.signal,
  })
  return data.data
}
